import React from 'react';

import SessionTokensLoader from './SessionTokensLoader';
import Stack from '../../Shared/UI/Stack/components/Stack';
import PageTitle from '../../Shared/UI/PageTitle/components/PageTitle';
import SessionTokensTable from './SessionTokensTable';
import SessionTokensPageController from './SessionTokensPageController';
import DeleteSessionTokenModal from './DeleteSessionTokenModal';
import Button from '../../Shared/UI/Button/components/Button';
import ActionRow from '../../Shared/UI/ActionRow/components/ActionRow';
import { useSessionTokensState, useSessionTokensActions } from './SessionTokensContext';
import { deleteExpiredSessionTokens } from './restApi';

import styles from './SessionTokens.module.scss';

const SessionTokens = () => {
  const sessionTokensState = useSessionTokensState();
  const { onResponse, onError } = useSessionTokensActions();

  const handleDeleteExpired = () => {
    const authenticityToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

    deleteExpiredSessionTokens({
      pageNumber: sessionTokensState?.pageNumber || 1,
      onResponse,
      onError,
      body: {
        authenticityToken,
      },
    });
  };

  return (
    <>
      <SessionTokensLoader />
      <div className={styles.pageLayout}>
        <Stack gap="lg">
          <PageTitle text={'Session Tokens'} />
          <ActionRow>
            <Button onClick={handleDeleteExpired}>
              Delete All Expired Session Tokens
            </Button>
          </ActionRow>
          <SessionTokensTable />
          <SessionTokensPageController />
        </Stack>
      </div>
      <DeleteSessionTokenModal />
    </>
  );
};

export default SessionTokens;
